<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Olá! Na aba MONITORAMENTO POR UNIDADE você encontra dois filtros de
        seleção:
      </h2>
      <div class="d-flex justify-center">
        <p class="col-6 mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No filtro <b>Selecione a unidade</b>, posicionado do lado esquerdo,
          está selecionada sua unidade organizacional.
        </p>
        <p class="col-6 mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No filtro <b>Selecione o Tipo de monitoramento</b>, posicionado no
          lado direito, você pode selecionar: <br>
          (1) <b>Comportamentos;</b><br>
          (2) <b>Competências Comportamentais.</b>
        </p>
      </div>
    </div>

    <div>
      <h2>1. Comportamentos</h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Ao selecionar (1) <b>Monitoramento de Comportamentos</b>, é possível
          analisar, por meio de gráficos e tabelas, os dados referentes a
          participação dos servidores no mapeamento comportamental da sua
          unidade.
        </p>
        <p class="mx-2 pa-2 text-center font-weight-bold text-lg-h6">
          Gráfico de barras, pizzas e tabela
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No gráfico de barras serão apresentadas informações sobre quantos
          comportamentos cada servidor cadastrou no período da realização do
          mapeamento comportamental.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No gráfico pizza, pode-se observar qual a maior tendência entre os
          comportamentos cadastrados pelos servidores da sua unidade:
          comportamentos que gostam, que não gostam ou que seriam ideais para
          seu ambiente de trabalho.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na tabela é possível observar a relação dos servidores da unidade e
          utilizar os recursos de ordenação, de forma crescente ou decrescente,
          por nome do servidor e quantidade de comportamentos.
        </p>
      </div>
    </div>

    <div>
      <h2>2. Competências Comportamentais</h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Ao selecionar (2)
          <b>Monitoramento de Competências Comportamentais</b>, é possível
          verificar, por meio de gráficos e tabelas, a distribuição dos
          comportamentos cadastrados pelos servidores da sua unidade, associados
          às Competências Comportamentais.
        </p>
        <p class="mx-2 pa-2 text-center font-weight-bold text-lg-h6">
          Gráfico de barras, pizzas e tabela
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No gráfico de barras, recomenda-se observar as competências com maior
          barra (representa o maior número de comportamentos associados) e as
          competências com menor número de comportamentos ou sem comportamentos
          associados (sem barra). Recomenda-se ainda verificar a categoria
          <b>“outros”</b>. Essa categoria inclui todos os cadastros que
          <b>não</b> são considerados comportamentos.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Outra forma de observar a associação dos comportamentos às
          competências é por meio de percentuais, como apresenta o gráfico
          pizza.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na tabela é possível observar de forma mais sintética as doze
          competências comportamentais definidas para o Programa de Gestão por
          Competências e a categoria <b>“outros”</b>.
        </p>
      </div>
    </div>

    <div>
      <h2>Importante!</h2>
      <div class="mx-2 pa-2 justify-center">
        <ul>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar essa aba <b>MONITORAMENTO POR UNIDADE</b>,
              filtro 1. <b>COMPORTAMENTOS</b>, para acompanhar a evolução da
              participação dos servidores no período do Mapeamento
              Comportamental;
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar essa aba <b>MONITORAMENTO POR UNIDADE</b>,
              filtro 2. <b>COMPETÊNCIAS COMPORTAMENTAIS</b>, após a conclusão do
              período do mapeamento comportamental, para identificar quais
              competências foram mais contempladas pela observação dos
              comportamentos dos servidores na sua unidade;
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Você pode trabalhar os dados expostos, por meio dos gráficos e
              tabelas, com sua equipe no intuito de verificar aspectos positivos
              e pontos de melhorias no contexto das competências destacadas;
            </p>
          </li>
        </ul>
      </div>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../../BaseTutorial';

export default {
  name: 'TutorialMonitoramentoMapeamentoUnidadeComportamental',

  components: { BaseTutorial },

  data() {
    return {
      steps: ['Introdução', 'Comportamentos', 'Competências Comportamentais', 'Importante'],
    };
  },
};
</script>
